import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
export default {
  props: {
    labelData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    minSum: {
      type: String,
      default: '0'
    },
    marginTop: {}
  },
  data: function data() {
    return {
      DataSum: [],
      Datatrea: [],
      obj: {},
      popArr: [],
      arr: [],
      time: [],
      seriesData: {},
      unitName: [],
      moveState: false,
      overflow: 'hidden'
    };
  },
  mounted: function mounted() {
    this.getrealData(); // if (this.labelData.length > 5) {
    //   this.Inter = setInterval(() => {
    //     console.log('mounted')
    //     setTimeout(() => {
    //       if (this.labelData.length > this.minSum) {
    //         this.labelData.push(this.labelData[0]) // 将数组的第一个元素添加到数组的
    //         this.labelData.shift() //删除数组的第一个元素
    //       }
    //     }, 500)
    //   }, 1500)
    // }
  },
  watch: {
    moveState: function moveState(value) {
      if (value) {
        this.overflow = 'auto';
      } else {
        this.overflow = 'hidden';
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.Inter);
  },
  scroll: function scroll() {
    var _this = this;

    setTimeout(function () {
      if (_this.labelData.length > 5) {
        _this.labelData.push(_this.labelData[0]); // 将数组的第一个元素添加到数组的


        _this.labelData.shift(); //删除数组的第一个元素

      }

      if (_this.dateList.length > 13) {
        _this.dateList.push(_this.dateList[0]); // 将数组的第一个元素添加到数组的


        _this.dateList.shift(); //删除数组的第一个元素

      }

      if (_this.dateLists.length > 7) {
        _this.dateLists.push(_this.dateLists[0]); // 将数组的第一个元素添加到数组的


        _this.dateLists.shift(); //删除数组的第一个元素

      }
    }, 500);
  },
  methods: {
    //实时数据请求
    getrealData: function getrealData() {
      var _this2 = this;

      //请求数据
      var params = {
        scopeId: 259,
        type: 1,
        scope: 1,
        st: 54
      };
      getAction('/online/st54/realtime/', params).then(function (res) {
        if (res.success) {
          // this.Datatrea = res.result.query.factors
          if (res.result.records.length > 0) {
            // if(type==1){
            res.result.query.factors.forEach(function (ele) {
              if (res.result.records[0].factor[ele.code]) {
                _this2.labelData.push({
                  title: ele.title,
                  unitName: ele.unitName,
                  value: res.result.records[0].factor[ele.code].value != null ? res.result.records[0].factor[ele.code].value : 0
                });
              }
            });
            _this2.moveState = !_this2.moveState;

            _this2.toggleState();
          } // res.result.query.factors.forEach((element) => {
          //   console.log('factors:', element.title)
          // })

        }
      });
    },
    toggleState: function toggleState() {
      var _this3 = this;

      console.log('123');
      this.moveState = !this.moveState;

      if (this.moveState) {
        if (this.Inter) {
          clearInterval(this.Inter);
        }
      } else {
        var data = JSON.parse(JSON.stringify(this.labelData));
        this.labelData = [];
        setTimeout(function () {
          _this3.labelData = data;

          if (_this3.labelData.length > 5) {
            _this3.Inter = setInterval(function () {
              setTimeout(function () {
                if (_this3.labelData.length > _this3.minSum) {
                  _this3.labelData.push(_this3.labelData[0]); // 将数组的第一个元素添加到数组的


                  _this3.labelData.shift(); //删除数组的第一个元素

                }
              }, 500);
            }, 1000);
          }
        }, 10);
      }
    },
    init: function init() {
      var _this4 = this;

      this.Inter = setInterval(function () {
        setTimeout(function () {
          if (_this4.labelData.length > _this4.minSum) {
            _this4.labelData.push(_this4.labelData[0]); // 将数组的第一个元素添加到数组的


            _this4.labelData.shift(); //删除数组的第一个元素

          }
        }, 500);
      }, 1000);
    }
  }
};